import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

import css from '../../../styles/instrument/trades/trades';

class TradeTable extends Component {
    static propTypes = {
        children: PropTypes.array,
        t: PropTypes.func.isRequired,
    }

    renderNoTrades() {
        return (
            <div>{this.props.t('stocks:lastDeals.noTrades')}</div>
        );
    }

    render() {
        const { children } = this.props;

        // @TODO: Do this with redux state
        if (!children || Object.keys(children).length < 1) {
            // @TODO: If before opening time (no trades), either:
            // Show notification (market opens at 09:00) and/or
            // show last trades from day before.
            return this.renderNoTrades();
        }

        const { t } = this.props;

        return (
            <table className={css.table}>
                <thead className={css.thead}>
                    <tr>
                        <th className={css.time}>{ t('date:time') }</th>
                        <th>{ t('price') }</th>
                        <th>{ t('volume') }</th>
                        <th>{ t('seller') }</th>
                        <th>&nbsp;</th>
                        <th>{ t('buyer') }</th>
                    </tr>
                </thead>
                <tbody>
                    {children}
                </tbody>
            </table>
        );
    }
}

export default translate('common')(TradeTable);



/** WEBPACK FOOTER **
 ** /src/shared/components/instrument/trades/TradeTable.js
 **/